import type { zhTW } from './zh-TW'

// 日本語：全 textKey を翻訳済み（zh-TW マスターと 0 gap）。Partial 構造なので、
// 万一の漏れも zh-TW にフォールバックし、raw key は決して表に出ない。
const jaJP: Partial<Record<keyof typeof zhTW, string>> = {
  'app.subtitle': 'JKBRα — 孤島サバイバル・毎日の挑戦',
  'auth.guest': 'ゲストで遊ぶ',
  'auth.login': 'ログイン',
  'auth.register': '新規登録',
  'auth.back': '戻る',
  'auth.handle.label': 'アカウントID',
  'auth.handle.ph': '3〜20文字（英数・_・-）',
  'auth.name.label': '表示名（任意）',
  'auth.name.ph': '他のプレイヤーに見せる名前',
  'auth.register.title': 'アカウント作成',
  'auth.register.submit': '作成して開始',
  'auth.login.title': 'ログイン',
  'auth.login.submit': 'ログインして開始',
  'auth.invalidHandle': 'IDは3〜20文字、英数字・アンダースコア・ハイフンのみです。',
  'auth.password.label': 'パスワード',
  'auth.password.ph': '8文字以上、英字と数字を含む',
  'auth.pending': '処理中…',
  'auth.err.bad_password': 'パスワードが弱すぎます：8文字以上かつ2種類以上の文字を含めてください。',
  'auth.err.handle_taken': 'このIDは既に使われています。別のIDをお試しください。',
  'auth.err.bad_credentials': 'IDまたはパスワードが違います。',
  'auth.err.offline': 'サーバーに接続できません。後でもう一度お試しください。',
  'rotate.title': '端末を縦に持ってください',
  'rotate.sub': '本ゲームは縦画面設計です。端末を縦向きに戻して続けてください。',
  'app.loading': '読み込み中…',
  'app.loadError': '一部のデータの読み込みに失敗しました。ページを再読み込みしてください。',
  'boot.tap': 'タップで開始',
  'boot.kbd': 'キーボード：方向キー/WASD 移動・R/H 休息・E 脱出・スペースで進行・数字キーで選択・Escで戻る',
  'boot.hint': '孤島サバイバル · 最後の一人が勝者',
  'menu.story': 'ストーリー',
  'menu.freeplay': 'フリーバトル',
  'menu.ranked': 'ランク',
  'menu.rankedOn': '🏅 ランクモード：オン（公平・補正なし）',
  'menu.rankedOff': '🏅 ランクモード：オフ（カジュアル）',
  'menu.settings': '設定',
  'menu.season': 'シーズン Lv.{lv}（{into}/{next}）',
  'menu.loading': 'アカウント読込中…',
  'menu.seasonCountdown': 'シーズン残り {days} 日',
  'menu.seasonEnded': '今シーズンは終了しました',
  'menu.seasonUpcoming': '新シーズンまもなく開始',
  'season.s1_tidefall': '第一シーズン「潮落」',
  'season.unnamed': '今シーズン',
  'menu.back': '戻る',
  'menu.chapterSelect': 'チャプター選択',
  'menu.chapterLocked': '🔒 前のチャプターをクリアすると解放',
  'menu.chaptersCleared': 'クリア {done}/{total} 章',
  'settings.title': '設定',
  'settings.pitch': '表示言語とゲーム効果音を調整します。設定はこの端末に保存されます。',
  'settings.language': '言語 / Language',
  'settings.kbd': '［1–4］言語を選択　［Esc］戻る',
  'settings.current': '現在の言語です。',
  'settings.audio': '効果音',
  'settings.soundOn': 'オン',
  'settings.soundOff': 'オフ',

  'hud.alive': '生存 {alive}/{total}',
  'hud.shrink': '次の禁止エリア拡大まで：{steps} 歩',
  'hud.weather': '天候：{weather}',
  'hud.fogHint': '🌫 視界不良',
  'hud.hp': 'HP',
  'hud.sp': 'SP',
  'hud.kills': '撃破 {n}',
  'hud.key': '🔑 ゲーム解除キー入手',
  'explore.gotLoot': '＋物資',
  'explore.areaEnemies': '⚠ このエリアに敵影 {n}',
  'explore.objective.title': 'このランの目標',
  'explore.objective.casual': '最後の生存者になるか、鍵持ちを倒して「脱出」で島を離れる。',
  'explore.objective.ranked': '毎日同じ seed のランク戦：ghost と bot を倒し、公平ルールでランキングへ。',
  'explore.log.open': 'ログ',
  'explore.log.title': 'アクションログ',
  'explore.log.close': 'ログを閉じる',
  'explore.intel.open': '情報',
  'explore.intel.close': '情報を閉じる',
  'explore.intel.enemies': '敵影 {n}',
  'explore.intel.key': '鍵持ち',
  'explore.intel.ghost': 'プレイヤー ghost',
  'explore.intel.lore': '場所の手がかり',
  'item.bandage': '包帯',
  'item.energy_drink': 'エナジードリンク',
  'item.painkiller': '鎮痛剤',
  'item.riceball': 'おにぎり',
  'item.vest_frag': '防弾ベストの破片',
  'item.radar': 'レーダー',
  'item.generic': '物資',
  'zone.unknown': '未知のエリア',
  'weapon.fists': '素手',
  'weapon.bat': '金属バット',
  'weapon.machete': 'ナタ',
  'weapon.saber': 'サーベル',
  'weapon.crossbow': 'クロスボウ',
  'weapon.dart': '麻酔ダート',
  'weapon.beretta': 'ベレッタ拳銃',
  'weapon.uzi': 'Uzi サブマシンガン',
  'weapon.shotgun': 'ショットガン',
  'weapon.grenade': '手榴弾',
  'app.title': 'バトルロイヤル α',
  'hud.danger': '⚠ このエリアはまもなく禁止区域になります。早く離れて！',
  'explore.kbd': '方向キー/WASD 移動・R/H 休息・E 脱出・Esc 退出',
  'explore.quit': '退出',
  'explore.quitConfirm': 'この対戦を放棄してメインメニューに戻りますか？',
  'menu.gacha': 'ガチャ',
  'menu.collection': 'コレクション',
  'menu.shop': 'ショップ',
  'menu.progress': 'シーズンパス',
  'menu.hubToday': '今日の戦場',
  'menu.hubPitch': 'ソロで出撃し、自律 bot と他プレイヤーの ghost に挑む。各ランでキャラ、シーズン、ランキングが進む。',
  'menu.hubFooter': '目標：最後の生存者になるか、鍵持ちを倒して脱出する。',
  'menu.story.badge': 'チュートリアル / 物語',
  'menu.story.desc': 'チャプターでルール、禁止区域、脱出、キャラの物語を学ぶ。',
  'menu.story.meta': '初回おすすめ',
  'menu.survival': 'サバイバル挑戦',
  'menu.survival.badge': 'ソロ Roguelite',
  'menu.survival.desc': '島に降り、探索し、戦い、魂で出撃キャラを解放する。',
  'menu.survival.meta': 'Casual',
  'menu.daily': 'デイリーランク',
  'menu.daily.badge': 'Async PvP',
  'menu.daily.desc': '同じ日替わり seed、プレイヤー ghost、公平ルールでランキングへ。',
  'menu.daily.meta': 'Ranked',
  'menu.collection.sub': '出撃 / 解放',
  'menu.collection.ready': '{n} 人のキャラを解放可能',
  'menu.collection.next': 'あと {n} 魂で解放',
  'menu.collection.complete': 'Roster 全解放済み',
  'menu.progress.sub': '任務 / BP 報酬',
  'menu.shop.sub': 'ジェム / 見た目',
  'shop.title': 'ジェムショップ',
  'shop.balance': '所持 💎 {gem}',
  'shop.bonus': 'ボーナス +{bonus}',
  'shop.confirm': '💎 {gem} を購入しますか？Stripe の安全な決済ページに移動します。',
  'shop.redirecting': '安全な決済ページへ移動中…',
  'shop.buy': '購入',
  'shop.success': '購入完了。💎 を付与しました。残高：{gem}',
  'shop.offline': 'ショップの購入にはアカウント接続が必要です。後でもう一度お試しください。',
  'collection.title': 'コレクション',
  'collection.empty': 'まだ何も持っていません。ガチャを引いて、お気に入りのキャラや衣装を集めよう！',
  'collection.offline': 'コレクションの表示にはアカウント接続が必要です。後でもう一度お試しください。',
  'collection.equipped': '装備中',
  'collection.tapEquip': 'キャラのカードをタップして外見を変更（能力に影響なし）',
  'collection.tapEquipShort': 'タップで外見装備',
  'collection.activeTitle': '出撃キャラ',
  'collection.tapDeploy': 'カードをタップして出撃キャラを選択（初期武器とパッシブに影響）',
  'collection.deploying': '出撃中',
  'collection.unlock.free': '初期',
  'collection.unlock.gacha': 'ガチャ',
  'char.c_default.name': 'デフォルト戦士',
  'char.c_kurotobi_nagi.name': '黒鳶 凪',
  'char.c_shiran_uta.name': '白蘭 詩',
  'passive.none': 'パッシブなし',
  'passive.first_blood': 'ファーストキル：怒気 +50',
  'fail.noBoon': '選べる強化がありません。',
  'log.boonOffer': '敵を撃破！強化を一つ選べます。',
  'log.boonTaken': '強化発動：{name}。',
  'boon.title': '強化を選択',
  'boon.generic': '強化',
  'boon.b_str.name': '猛攻',
  'boon.b_str.desc': '攻撃 +6',
  'boon.b_guard.name': '堅守',
  'boon.b_guard.desc': '防御 +5',
  'boon.b_focus.name': '集中',
  'boon.b_focus.desc': '技巧 +5',
  'boon.b_plate.name': '装甲',
  'boon.b_plate.desc': 'アーマー +4',
  'boon.b_vigor.name': '活力',
  'boon.b_vigor.desc': '最大HP +30（即時回復）',
  'boon.b_endure.name': '持久',
  'boon.b_endure.desc': '最大SP +25（即時回復）',
  'collection.souls': '魂：{n}',
  'collection.unlockCost': '🔒 {n} 魂',
  'collection.cantAfford': '魂が足りません。試合を重ねて魂を貯めましょう。',
  'collection.gachaOnly': 'ガチャ入手',
  'collection.gachaOnlyNote': 'このキャラはガチャで入手します（オンライン要）。',
  'result.souls': '+{n} 魂（合計 {balance}）',
  'leaderboard.title': 'ランキング',
  'leaderboard.pitch': '同じ日替わり seed でプレイヤー ghost と競争し、公平ルールでランキングへ。',
  'leaderboard.open': '🏆 シーズンランキング',
  'leaderboard.season': 'シーズン：{id}',
  'leaderboard.empty': '今シーズンはまだ順位がありません。一戦してランクインしよう！',
  'leaderboard.offline': 'ランキングの読み込みにはアカウント接続が必要です。後でお試しください。',
  'leaderboard.points': '{n} pt',
  'leaderboard.you': 'あなた',
  'leaderboard.casual': 'カジュアル',
  'leaderboard.ranked': 'ランク',
  'tier.bronze': 'ブロンズ',
  'tier.silver': 'シルバー',
  'tier.gold': 'ゴールド',
  'tier.platinum': 'プラチナ',
  'tier.diamond': 'ダイヤ',
  'tier.master': 'マスター',
  'leaderboard.me': 'あなたの順位：{rank} 位（{points} pt）',
  'leaderboard.meNone': 'まだランクインしていません——一戦完了でランクインします。',
  'gacha.title': 'ガチャ',
  'gacha.titlePreview': 'ガチャ（プレビュー）',
  'gacha.pitch': 'キャラと見た目を入手して出撃選択を広げる。ランクモードは公平ルールを維持し、戦力優位は販売しない。',
  'gacha.results.empty': 'まだ引いていません。10連のキャラ、見た目、素材結果がここに表示されます。',
  'gacha.pull10': '10連ガチャ',
  'gacha.pull10Preview': '10連（プレビュー）',
  'gacha.cost': '10連ごとに {n} ジェム',
  'gacha.pity': '天井 SSR まで：あと {n} 連',
  'gacha.pityReady': '次の1連で SSR 確定！',
  'gacha.balance': '💎 {gem}　🪙 {coin}',
  'gacha.broke': 'ジェムが足りず、ガチャを引けません。',
  'gacha.offline': 'サーバーに接続できません。現在プレビュー表示です。後ほどお試しください。',
  'gacha.kbd': '［スペース/Enter］ガチャ　［Esc］戻る',
  'gacha.ssr': 'SSR',
  'gacha.sr': 'SR',
  'gacha.r': 'R',
  'status.weapon': '武器：{w}',
  'combat.miss': '外れ',
  'combat.rage': '怒り',
  'combat.you': 'あなた',
  'combat.kbd': '［スペース］攻撃　［S］必殺　［Esc］逃走',
  'action.special': '必殺技！',
  'fail.noRage': '怒りが足りず、必殺技を出せない。',
  'fail.generic': 'その行動は今はできない。',
  'log.special': '怒りを爆発させ、渾身の一撃！',
  'log.serverState': '【サーバ】生存 {alive}/{total}　·　{step}歩目　·　順位 {rank}',

  'action.attack': '攻撃 {name}',
  'action.attackWith': '攻撃（{w}）',
  'action.escape': '脱出',
  'action.flee': '逃げる',
  'rest.sleep': '睡眠（SP回復）',
  'rest.heal': '治療（HP回復）',

  'fail.forbidden': '⚠ そこは禁止エリア。首輪が爆発する。',
  'fail.sameZone': 'すでにこの場所にいる。',
  'fail.noSp': 'スタミナ不足。少し休もう。',
  'fail.deadAct': 'あなたは死亡しており行動できない。',
  'fail.noKey': 'まだ解除キーを持っていない。',
  'fail.notRunning': 'ゲームはまだ始まっていない。',

  'log.deploy': '{zone} に投下された。生存開始。',
  'log.move': '{zone} へ移動した。',
  'log.search.nothing': '注意深く探したが、何も見つからなかった。',
  'log.search.item': '{item} を見つけた！',
  'log.search.weapon': '武器を拾った：{item}！',
  'log.pickup.serverManaged': '{item} を眺めた（オンライン戦：物資はサーバーが管理）。',
  'log.rest.sp': 'しばし休み、スタミナ +{n}。',
  'log.rest.hp': '傷を手当てし、HP +{n}。',
  'log.rest.spFull': 'ひと息ついたが、スタミナはとうに満タンだった。',
  'log.rest.hpFull': '傷を確かめたが、手当ての必要はなかった。',
  'log.encounter': '{zone} で {name} と遭遇！',
  'log.ambush': '{name} が襲いかかってきた！',
  'log.attackHit': '{name} に {dmg} のダメージ！',
  'log.attackMiss': '攻撃は外れた。',
  'log.counterHit': '{name} の反撃、{dmg} のダメージを受けた！',
  'log.injury': '{who} の {part} を負傷！',
  'log.injurySelf': 'あなたの {part} を負傷！',
  'log.crit': 'クリティカル！',
  'log.youKilled': '{name} を倒した！',
  'log.youDied': '{name} に殺された。',
  'log.botKill': '{killer} が {victim} を殺した。',
  'log.collar': '{name} は禁止エリアに残り、首輪が爆発した。',
  'log.broadcast': '【放送】次の地点が禁止エリアになる：{zones}。',
  'log.keyDrop': '{name} から 🔑 解除キーを奪った！',
  'log.keyLost': '【放送】{name} が禁止エリアで命を落とし、🔑 解除キーは別の生徒の手に渡った。',
  'log.enemyHit': '{name} の攻撃、{dmg} のダメージ！',
  'log.enemyMiss': '{name} の攻撃は外れた。',
  'log.hazard': '荒野の危険で HP を {n} 失った。',
  'log.youDiedEnv': '深手に耐えきれず、倒れ込んだ……',
  'log.fled': '戦闘から離脱した。',
  'log.targetGone': '相手はもうここにいない。',
  'log.actionFailed': '操作に失敗しました。もう一度お試しください。',

  'part.b': '胸',
  'part.h': '頭',
  'part.a': '腕',
  'part.f': '足',
  'arch.player': 'あなた',
  'arch.hunter': 'ハンター型',
  'arch.survivor': '逃亡型',
  'arch.looter': '収集型',
  'arch.veteran': '老兵型',
  'arch.medic': '協調型',
  'arch.boss': '監督教官',

  'weather.w0': '晴れ',
  'weather.w1': '快晴',
  'weather.w2': '曇り',
  'weather.w3': '小雨',
  'weather.w4': '豪雨',
  'weather.w5': '台風',
  'weather.w6': '雷雨',
  'weather.w7': '雪',
  'weather.w8': '霧',
  'weather.w9': '濃霧',
  'weather.unknown': '天候不明',

  'result.win.survivor': '最後の生存者',
  'result.win.escape': '島から脱出',
  'result.lose': '脱落',
  'result.rank': '順位：{rank} / {total}',
  'result.kills': '撃破数：{n}',
  'result.survived': '生存ステップ：{n}',
  'result.rewards': 'リザルト報酬',
  'result.nextTitle': '次にすること',
  'result.nextCollection': '魂で出撃キャラを解放し、次のランに新しい初期武器とパッシブを持ち込む。',
  'result.nextUnlockReady': '{n} 人を解放できる魂があります。コレクションで初期武器とパッシブを変えよう。',
  'result.nextUnlockSoon': '次のキャラ解放まであと {n} 魂。次のランの明確な目標です。',
  'result.nextUnlockComplete': '出撃キャラは全解放済み。シーズンパスとランキングを進めよう。',
  'result.gainCoin': 'コイン +{n}',
  'result.gainXp': 'シーズン経験値 +{n}',
  'result.levelUp': 'シーズンレベルアップ：Lv.{from} → Lv.{to}',
  'result.seasonLv': 'シーズンレベル Lv.{lv}',
  'result.missionDone': 'デイリー達成：{name}',
  'result.settleOffline': '（精算オフライン、後で同期）',
  'mission.play_1': '1 戦プレイ',
  'mission.kill_3': '3 体撃破',
  'mission.survive_20': '20 ステップ生存',
  'mission.generic': 'デイリーチャレンジ',
  'progress.title': 'シーズン進捗',
  'progress.daily': 'デイリーミッション',
  'progress.mission': '{name}　{cur}/{goal}',
  'progress.reward': '・報酬 コイン{coin}/経験{xp}',
  'progress.offline': '進捗はオンライン必須（?backend=1 でサーバー起動）。',
  'bp.title': 'シーズンパス',
  'bp.claimable': '受取可能 {n} 件',
  'bp.claim': '報酬を受取',
  'bp.none': '受取可能な報酬はありません',
  'bp.gained': '受取：コイン +{coin}、アイテム ×{items}',
  'bp.hint': 'シーズンパスに受取可能 {n} 件（タップして受取）',
  'bp.track': 'パストラック　受取済 {claimed}/{total} 段階',
  'gacha.pulling': '抽選中…',
  'gacha.confirm.q': '{n} 💎を消費して10連ガチャを引きますか？（残高 {bal} 💎）',
  'gacha.confirm.yes': '引く',
  'gacha.confirm.no': 'キャンセル',
  'gacha.confirm.pity': '今回はSSR確定！',
  'gacha.loading': '読み込み中…',
  'result.settling': '精算中…',
  'bp.claiming': '受取中…',
  'bp.levelLine': 'Lv.{lv}　コイン {coin}{item}',
  'bp.kind.skin': '＋衣装',
  'bp.kind.material': '＋カケラ',
  'bp.kind.char': '＋キャラ',
  'bp.kind.other': '＋アイテム',
  'result.again': 'もう一度',
  'result.toCollection': 'キャラ解放',
  'result.toPass': 'シーズンパス',
  'result.toMenu': 'メニューへ',
  'result.kbd': '［Enter］もう一戦　［Esc］メニューへ',
  'result.l-survivor': '最後まで生き延び、唯一の生存者となった。',
  'result.l-escape': 'キーを奪い島を脱出、このゲームから解き放たれた。',
  'result.l-dead': 'ゲームは続くが、あなたの物語はここで終わる。',

  'zone.north_peak.name': '北の山頂',
  'zone.cliff.name': '断崖',
  'zone.lighthouse.name': '灯台',
  'zone.north_temple.name': '北の寺',
  'zone.north_knoll.name': '北の丘',
  'zone.central_pond.name': '中央の池',
  'zone.west_pond.name': '西の池',
  'zone.tourism.name': '観光協会ビル',
  'zone.houses_north.name': '民家（北）',
  'zone.clinic.name': '診療所',
  'zone.school.name': '学校（常時禁止）',
  'zone.thicket.name': '雑木林',
  'zone.shrine.name': '神社',
  'zone.farm_assoc.name': '農協ビル',
  'zone.fish_assoc.name': '漁協ビル',
  'zone.south_peak.name': '南の山頂',
  'zone.south_temple.name': '南の寺',
  'zone.reservoir.name': '貯水池（ダム）',
  'zone.port.name': '港',
  'zone.north_peak.desc': '島北部の高台。視界が開け、海域と島の半分を見渡せる。',
  // ── Zone lore（北部の地点・分割翻訳。残りは zh-TW にフォールバック）──
  'zone.north_peak.lore': '山頂に立てば敵の動きはつかめるが、自分の姿も隠せなくなる。',
  'zone.cliff.lore': '行き場を失った者の中には、ここから身を投げる者もいた。',
  'zone.lighthouse.lore': '一団がここに立てこもったが、疑心と一袋の毒薬が、仲間同士の撃ち合いへと変えた。',
  'zone.north_temple.lore': '夜が更けると、ここはぞっとするほど不気味になる。',
  'zone.north_knoll.lore': '起伏のある地形は伏撃に向く——伏撃される側にとっても。',
  'zone.central_pond.lore': '池というより沼に近く、どこか不安をかき立てる。',
  'zone.west_pond.lore': '水を求める者が来る場所だが、ここは静かすぎる。',
  'zone.tourism.lore': 'かつて誰かがここにPCを持ち込み、主催側のシステムに侵入してゲームを終わらせようとした。',
  'zone.houses_north.lore': '住民はとうに強制退去させられ、残るのは隠れ潜む者の押し殺した息だけ。',
  'zone.clinic.lore': '傷ついた者は皆ここを目指す——だからこそ、最も危険な場所でもある。',
  'zone.school.lore': 'ここは「常時禁止区域」。足を踏み入れれば首輪が起動する——監督教官が中から君たちを見ている。',
  'zone.thicket.lore': '林の中で襲われれば、身構える間もない——ここは冷酷な狩人の狩場だ。',
  'zone.shrine.lore': '名も知れぬ神が、忘れられたまま祀られている。',
  'zone.farm_assoc.lore': '鎌も鍬も、この島では凶器に変わる。',
  'zone.fish_assoc.lore': '窓からは港が見える——そして、優勝者を待つあの船も。',
  'zone.south_peak.lore': '守るに易く攻めるに難い。最後の抵抗に向いている。',
  'zone.south_temple.lore': '昼間はまだしも、夜になるとここはひどく薄気味悪い。',
  'zone.reservoir.lore': '開けた水辺は身を隠す場所もないが、避けて通れぬ水源だ。',
  'zone.port.lore': '兵士と優勝者が島を出る、唯一の出口だ。',
  'zone.beach.lore': '海を望めば、巡回する船ばかりが目につき、逃げ場のなさを思い知らされる。',
  'zone.houses_south.lore': '物資を漁るなら急ぐことだ——それは誰もが同じ考えだ。',
  'zone.cliff.desc': '海に臨む切り立った断崖。潮風が唸り、足元では波が岩礁を打つ。',
  'zone.lighthouse.desc': '東岸に建つ白い灯台。島で最も目立つ目印だ。',
  'zone.north_temple.desc': '北部の山腹にある寺。線香はとうに絶え、仏像が影の中で沈黙している。',
  'zone.north_knoll.desc': 'ススキに覆われた小丘。風が吹くたびにさわさわと鳴る。',
  'zone.central_pond.desc': '島中央の池。水面が空を映し、周囲には葦が茂る。',
  'zone.west_pond.desc': '西側の小さな池。水は暗い緑で、岸はぬかるんで歩きにくい。',
  'zone.tourism.desc': '廃れた沖木島観光協会の庁舎。机には色あせた観光パンフレットが残る。',
  'zone.houses_north.desc': '北側の住宅地。戸は開け放たれ、食卓の料理はとうに冷えている。',
  'zone.clinic.desc': '島で唯一の診療所。薬棚はほぼ空で、消毒液の匂いが残る。',
  'zone.school.desc': '君たちが投下された学校。今は主催側の本部で、近づくと首輪が鳴り出す。',
  'zone.thicket.desc': '鬱蒼とした雑木林。枝葉が空を覆い、視界は数歩先までしかない。',
  'zone.shrine.desc': '南部の神社。鳥居は色褪せ、石段は苔に覆われている。',
  'zone.farm_assoc.desc': '農業協会の倉庫棟。錆びた農具と袋詰めの肥料が積まれている。',
  'zone.fish_assoc.desc': '漁業協会の建物。潮の生臭さが漂い、壁には古びた漁網が掛かる。',
  'zone.south_peak.desc': '南部の峰。奇岩が連なり、北の山ほど見晴らしは利かない。',
  'zone.south_temple.desc': '南部の寺院。堂宇は荒れ、蜘蛛の巣が張り巡らされている。',
  'zone.reservoir.desc': '島全体に水を供給する貯水池と小さなダム。静寂の中で水音がやけに澄んで聞こえる。',
  'zone.port.desc': '島南の港。数隻の船が停泊し、纜が風に揺れる。',
  'zone.beach.desc': '南岸の砂浜。波が次々と打ち寄せ、遠くには巡回する監視船が見える。',
  'zone.houses_south.desc': '南側の住宅街。店は他より多いが、棚はとうに空にされている。',
  'zone.beach.name': '砂浜',
  'zone.houses_south.name': '民家（南）',

  'story.tap': '▶ タップで続行',
  'story.kbd': '［スペース/Enter］進む　［1–3］選択　［Esc］戻る',
  'story.enterMatch': '⚔ 戦場へ',
  'story.complete': '章クリア',
  'story.allComplete': '～ 全編完結 ～',
  'story.toMenu': 'メインメニュー',
  'story.broken': 'この章は今は進められません。メインメニューに戻ってもう一度お試しください。',

  's.char.you': 'あなた',
  's.char.sakura': '立花 さくら',
  's.char.rin': '黒沢 凛',
  's.char.kaede': '一ノ瀬 楓',
  's.char.hikari': '望月 ひかり',
  's.char.officer': '監督教官',
  's.char.voice': '放送',

  's.prologue.title': '序章：はじまり',
  's.ch1.title': '第一章：最初の夜',
  's.ch2.title': '第二章：信頼と裏切り',
  's.ch3.title': '第三章：観光協会の信号',
  's.ch4.title': '第四章：狩る者',
  's.ch5.title': '第五章：首輪の秘密',
  's.ch6.title': '終章：夜明け',

  // 章あらすじ
  's.prologue.sum': '修学旅行が、ガスの後で一変した。見知らぬ島で目を覚ますと、首には冷たい首輪がはめられていた。',
  's.ch1.sum': '孤島に夜が訪れる。最初の放送が鳴り、禁止エリアが広がり始める。恐怖と信頼の間で、最初の選択を迫られる。',
  's.ch2.sum': '同盟は生存を延ばす——あるいは、より惨い死を呼ぶ。物資が尽きたとき、誰がまだ味方でいてくれる？',
  's.ch3.sum': '廃れた観光協会ビルで、楓は運営のシステムを麻痺させる手段を見つけた——だが、時間が尽きていく。',
  's.ch4.sum': '凛はもう隠れない。冷静かつ正確に、名簿の名を一つずつ消していく。次は——あなたか？',
  's.ch5.sum': 'この島を出る唯一の方法は、全員の首にある首輪の中に隠されている。代償は、誰かが命がけで試すこと。',
  's.ch6.sum': '空が白む頃、島に残るのはわずか数人。あなたは生存者か、脱出者か、それとも卓を引っくり返す者か。',

  // 序章
  's.prologue.s1.1': '修学旅行のバスが山道を走る。窓の外を緑が流れていく。まぶたが重い。',
  's.prologue.s1.2': '甘ったるい匂いが車内に忍び込む。級友たちが一人、また一人と頭を垂れていく。',
  's.prologue.s1.mid': '隣の席の同級生を揺り起こそうと手を伸ばすが、指先はどんどん重くなる。最後に目に映ったのは、運転席の後ろ——いつの間にか外側から施錠された仕切り板だった。',
  's.prologue.s1.3': '叫ぼうとしても、声が出ない。目の前が暗くなり——',
  's.prologue.s2.1': '冷たい床。まぶしい蛍光灯。見知らぬ教室で目を覚ます。',
  's.prologue.s2.wake': '倒れた同級生を無意識に数える。数えるほど、数字は乱れていく。指先が首筋に触れた——いつの間にか嵌められた、冷たい金属の輪。その瞬間ようやく悟る。これは悪夢ではない。目覚めることこそが、悪夢の始まりなのだと。',
  's.prologue.s2.officer': '「全員起きたか？よし。今期の『プログラム』会場へようこそ。」',
  's.prologue.s2.officer2': '彼は手元のクリップボードを開き、ごく普通の行程表でも読み上げるような口調で言った。「受付、適応、淘汰——手順は座席の下のしおりに印刷してある。ああ、非常口はもう溶接で塞いだ。前回の連中が、教えてくれたんでね。」',
  's.prologue.s2.2': '首に手をやると——冷たい金属の輪が、どうやっても外れない。',
  's.prologue.s2.sakura': '「だ、だめ……それに触らないで！無理に外すと爆発するって、教官が……」',
  's.prologue.s2.after': 'あなたはそっと手を下ろした。少女の声は震えていたが、それでも誰かを落ち着かせようと気丈に振る舞っていた——その眼差しを、そして自分の手のひらに滲む冷たい汗を、あなたは忘れなかった。',
  's.prologue.s3.officer1': '「ルールは単純だ。最後の一人になるまで殺し合え。残った者だけが、生きて島を出られる。」',
  's.prologue.s3.officer2': '「島は時間とともに『禁止エリア』に区切られる。時間が来てもそこに残れば、首輪が秒読みを始める。」',
  's.prologue.s3.officer3': '「各自に食料と武器を一つずつ。運の良し悪しは自分で背負え。ゲーム開始だ。」',
  's.prologue.s3.after': '教室は死んだように静まり返り、やがて押し殺した嗚咽、倒れる椅子、出口へ走り出しては見えない境界線に押し戻される者——。監督教官はただ腕を組み、何度も予行してきた芝居でも眺めるように立っていた。カウントダウンは、もう始まっている。',
  's.prologue.s4.q': '隣の級友が突然立ち上がり、叫び出した。あなたは——',
  's.prologue.s4.cA': '冷静になり、まず状況を見極める',
  's.prologue.s4.cB': '教官にこの意味を問いただす',
  's.prologue.s4.rA': '震えを抑え、冷静に周囲を見回す。生き延びるには、まずルールを把握することだ。',
  's.prologue.s4.rA.after': '表情を変えず、いくつかのことを頭に刻む——監督教官の腰のリモコン、ドアの脇に立つ黒服の監視役、壁で赤いランプを灯し続けるカメラ。感情は助けにならない。だが、この観察は役に立つかもしれない。',
  's.prologue.s4.rB': '「なぜこんなことを？」と問う。',
  's.prologue.s4.rB.officer': '教官はただ笑った。「『なぜ』と聞く奴は、たいてい長く生きられない。」',
  's.prologue.s4.rB.after': '教官の視線が、あなたの顔の上に一秒だけ長くとどまる。まるで番号に印をつけるように。周りの同級生はそっと半歩離れた——この島では、出る杭ほど真っ先に打たれる。あなたは悔しさを呑み込み、心に刻む。ある種の問いは、生き延びることでしか答えられないのだと。',
  's.prologue.s4.cC': '取り乱した隣の級友をなだめる',
  's.prologue.s4.rC': '震えるその級友の肩に手を置き、声を落として何かを告げる。',
  's.prologue.s4.rC.after': '叫びはやがて荒い息づかいへと変わり、教室に張りつめた空気も、ほんの少しだけ緩んだ気がした。監督教官はあなたをちらりと見たが、何も言わなかった。ふと気づく——ここでは、わずかな落ち着きさえ一種の抵抗なのだと。そして人は覚えている。誰が最初に手を差し伸べたのかを。',
  's.prologue.s5.1': '生徒たちは校門から追い出され、島の各所に投下された。潮風が吹き、夜は深い。',
  's.prologue.s5.sakura': '「待って！あなたなのね……よかった。わたしたち……一緒に行動しない？」立花さくらが手を差し出す。',
  's.prologue.s5.q': 'あなたは——',
  's.prologue.s5.cA': 'さくらと共に行く',
  's.prologue.s5.cB': '断って、一人で動く',
  's.prologue.s5.rA': 'その震える手を握った。少なくとも今は、一人じゃない。',
  's.prologue.s5.rA.sakura': '「……ありがとう。」さくらは涙ながらに笑い、君の手を握り返した。「これから何があっても、一緒に乗り越えよう。」',
  's.prologue.s5.rA.end': 'ふたつの影が並んで夜に溶けていく。ゲームはまだ始まったばかり——それでも今夜だけは、互いの呼吸を数えてくれる誰かがいる。',
  's.prologue.s5.rB': '「ごめん……一人のほうが安全だ。」闇に背を向けると、背後に小さなため息が聞こえた。',
  's.prologue.s5.rB.mid': '君は振り返らなかった。この島では、情の脆さや迷いは、刃よりも先に人の命を奪う——そう自分に言い聞かせ、あのため息を、そして胸の奥の何かもっと柔らかいものごと、背後に置き去りにした。',
  's.prologue.s5.rB.end': '闇はすぐにあのため息を呑み込んだ。ひとり歩くあなたに、足音だけがこの島で唯一の返事をくれる。',
  's.prologue.s5.cC': '同行する。ただし先に約束を',
  's.prologue.s5.rC': '「一緒に行こう。」あなたは一拍おいて続けた。「でも先に決めておく——抜けたい者はいつでも抜けていい。借りも貸しもなしだ。」',
  's.prologue.s5.rC.sakura': '「……うん、それがいい。」さくらは手を引っ込め、しっかりと頷いた。「無理もしない、裏切りもしない。これがわたしたちの最初の約束ね。」',
  's.prologue.s5.rC.end': '誓いはない。あるのは、誰でもいつでもほどける一本の縄だけ。けれどほどけるからこそ、その夜の歩みは不思議と落ち着いていた。',

  // 第一章
  's.ch1.s1.scene': '日が落ち、あなたはこの島の闇へと押し出された。手にあるのは粗末な地図と懐中電灯、そして押しつけられた武器だけ。校舎の輪郭が遠くで黒い影に沈み、級友たちは思い思いに夜へ散っていく——じきに、その足音さえ聞こえなくなった。',
  's.ch1.s1.voice': '【放送】諸君、こんばんは。次の地点はまもなく禁止エリアとなる。速やかに離れよ……',
  's.ch1.s1.1': '冷たい機械音の放送が、島の隅々まで響く。生き残りのカウントダウンが始まった。',
  's.ch1.s1.mid': '放送の口調は丁寧すぎて、かえって背筋が凍る。自分に言い聞かせる——同じ教室で過ごした相手が、刃を向け合うはずがない、と。だが暗闇で近づく足音が、その甘さを一歩ずつ剥ぎ取っていく。',
  's.ch1.s2.1': '暗闇の中、ひとつの影がよろめきながら駆け寄る。手の中で何かが光った——望月ひかり、泣いている。',
  's.ch1.s2.hikari': '「ごめんなさい、ごめんなさい……死にたくない！あなたさえ片付ければ、わたしは……！」',
  's.ch1.s2.q': '彼女が刃を振りかざして飛びかかる。あなたは——',
  's.ch1.s2.cA': '刃を奪い、彼女を止める',
  's.ch1.s2.cB': '反射的に反撃する',
  's.ch1.s2.cC': '背を向けて逃げる',
  's.ch1.s2.rA': '手首を押さえると、ナイフが落ちた。彼女は崩れ落ち、泣きじゃくる。一人救った——同時に、火種も残した。',
  's.ch1.s2.rA.hikari': '「どうして……どうして反撃しないの？」ひかりは涙に濡れた顔を上げ、声を震わせた。「わたし、あなたを殺すところだった。なのに……ありがとう。わたし自身の手から、わたしを引き戻してくれて。」',
  's.ch1.s2.rA.after': '彼女を助け起こすと、手のひらにまだ震える手が触れた。この瞬間に救ったのが彼女なのか、それとも自分の中のまだ屈したくない何かなのか、うまく言えない。けれど分かっている——手を差し伸べる気持ちが残っているうちは、この島が望む姿に、まだ堕ちきってはいないのだと。',
  's.ch1.s2.rB': '頭より先に体が動いた。我に返ると、彼女は血だまりに倒れ、瞳に恐怖を凍らせていた。最初の一人を殺した。',
  's.ch1.s2.rB.after': '手の震えが止まらない。なのに手のひらの温もりだけは、どうしても消えない。吐きたい、跪いて詫びたい、これは現実じゃないと思いたい——だが島は時間をくれない。あなたは無理に背を伸ばし、「ごめん」を喉の奥へ呑み込む。この重さは覚えておけ。けれど、今それに潰されるな。生き延びてこそ、懺悔する資格がある。',
  's.ch1.s2.rC': '泣き声を背に、全力で走り出す。逃げるのは恥じゃない——だが島は縮む。いつか、逃げ場はなくなる。',
  's.ch1.s2.rC.after': '遠くまで走っても、あの泣き声は鼓膜に刺さったまま離れない。彼女を殺しもせず、救いもせず——ただ、次に出会う誰かへ選択を押しつけただけ。それが「きれいな」やり方かどうかは分からない。分かるのは、自分の手のひらも同じく、冷や汗でびっしょりだということ。',
  's.ch1.s3.1': '廃屋に逃げ込み、息を整える。隅から、落ち着いた声がした。',
  's.ch1.s3.kaede': '「落ち着いて、武器は持ってない。一ノ瀬楓よ。考えてたの——この首輪、このシステム、きっと穴がある。」',
  's.ch1.s3.2': '彼女は島の略図を広げ、東の観光協会ビルを指した。',
  's.ch1.s3.kaede2': '「あそこにコンピュータと回線がある。時間をくれれば、全員の首輪を一斉に無効化できるかも。賭けてみる？」',
  's.ch1.s3.cA': '「賭ける。お前の言うその“穴”を信じる。」',
  's.ch1.s3.cB': '「賭ける。ただし自分の逃げ道は残す。」',
  's.ch1.s3.cC': '「システムには賭けない。自分が生きて出ることだけに賭ける。」',
  's.ch1.s3.rA': '君は迷わなかった。楓は一瞬きょとんとして、すぐに目を細めた。',
  's.ch1.s3.rA.kaede': '「……ありがとう。何の留保もなく信じてもらえると、人は必死になれるものね。三日——いえ、次の縮小までに片をつける。」',
  's.ch1.s3.rB': '君は引き受けた。ただし言葉には抜かりがない。楓は気を悪くするどころか、頷いた。',
  's.ch1.s3.rB.kaede': '「賢いね。他人の未検証の計画に命を張るなんて、そもそも愚かなこと。逃げ道は確保して——そして、できれば使わずに済ませて。」',
  's.ch1.s3.rC': '君ははっきりと言い切った。楓はしばし黙り、反論しなかった。',
  's.ch1.s3.rC.kaede': '「……そうね。命を懸けて付き合えとは言えない。なら、別々に行こう。でも気が変わったら——観光協会のビルで待ってる。」',
  's.ch1.s4.1': '窓の外を、落ち着いた影がよぎる。黒沢凛——クラスで最も冷静な人間。その手には今、銃があった。',
  's.ch1.s4.rin': '「楓の計画？美しいわ。でも成功する前に、わたしが名簿を片付ける。あなたたちもね。」',
  's.ch1.s4.2': '彼女は撃たず、一言だけ残して夜に消えた。脅威は、形になった。',
  's.ch1.s4.after': '凛の足音は夜に呑まれ、それでもあの一言は背中に貼りついて離れない。あなたはようやく悟る——この島で最も恐ろしいのは、叫びながら襲ってくる者ではない。お前がいつ死ぬべきかを、とうに計算し終え、淡々と引き金を引く者だ。',
  's.ch1.s5.1': '夜はまだ長い。禁止エリアは広がり続け、あなたはこの島へ踏み出し、生き延びねばならない。',
  's.ch1.s5.sakura': '「あいつらの書いた筋書き通りには死なない。たとえ皆の名前を覚えているのが私一人になっても——それごと、この島から連れて出る。」',
  's.ch1.s5.2': '立花さくらは手のひらの冷たい番号札を握りしめた。恐怖はまだある。だが初めて、それは形を持った——彼女が砕くと決めた形を。',
  's.ch1.s5.end': '潮風が遠くの放送のノイズを巻き上げる。まるで急かすように。さくらがあなたに小さくうなずいた——退路のない最初の一歩を、今ここから踏み出す。',

  // 第二章
  's.ch2.s1.scene': 'この島の時間は「放送の点呼」で刻まれる——数時間ごと、冷たい女の声が新たな死者の番号を読み上げ、名簿は少しずつ短くなる。あなたは通報の合間に動き、通報の瞬間に息を殺すことを覚えた。日々は、数字の引き潮になっていく。',
  's.ch2.s1.voice': '【放送】定時点呼。新たな除名番号——〇四、一七、二二、三〇。名簿が、また一段と短くなりました。生存者諸君、どうか罪悪感より長く生きられますように。',
  's.ch2.s1.1': '二日が過ぎ、リュックの食料は尽きた。民家に潜み、月明かりでわずかな物資を数える。',
  's.ch2.s1.mid': '飢えは物音を、そして疑いをも増幅する。ふと気づく——この島で最初に底を突くのは食糧ではなく、「誰かを信じられる」という心の余裕なのだと。',
  's.ch2.s1.2': '外で足音。息を殺す——楓だ。表情が険しい。',
  's.ch2.s2.kaede': '「誰かが偽の情報を流して、級友を禁止エリアへ誘い込んでる。このままじゃ、誰かが手を下すより早く名簿が空になる。」',
  's.ch2.s2.q': '楓はその流言の主を暴くのを手伝えと言う。だが、彼女の情報を丸ごと信じていい？',
  's.ch2.s2.cA': '楓を信じ、計画に従う',
  's.ch2.s2.cB': '一手残し、自分で確かめる',
  's.ch2.s2.rA': 'うなずく。この島でまだ嘘を暴こうとする人間なら、賭ける価値はある。',
  's.ch2.s2.rA.kaede': '楓は一瞬、言葉を失った。こんなにあっさり頷かれるとは思っていなかったらしい。視線を逸らし、いつもより低い声で——「……ありがとう。ここじゃ、背中を預けられる相手なんてそういない。後悔はさせない。今度こそ、約束する。」',
  's.ch2.s2.rA.after': '楓の情報がどこまで本当かは分からない。でも、これだけは分かる——嘘を暴こうとする者すら信じられないなら、この島には本当に嘘しか残らない。背中を預けるのは賭けだ。あなたは、まだ本当のことを言おうとする人間に、まず賭けることを選んだ。',
  's.ch2.s2.rB.before': '君は首を横に振り、彼女の計画にすぐは乗らなかった。情報は参考にする——だが、自分の目で確かめてからでなければ信じない。',
  's.ch2.s2.rB': '「自分で確かめてからにする。」楓は怒らず、静かに言った。',
  's.ch2.s2.rB.kaede': '「慎重なのは正しい——誰も信じられなくなるほどでなければね。」',
  's.ch2.s2.cC': '表向きは応じ、内心で警戒を残す',
  's.ch2.s2.rC': 'あなたは頷き、ちょうどよく微笑む——心の中では退路と疑点を一つずつ刻みつけながら。同盟も本物、警戒も本物だ。',
  's.ch2.s2.rC.kaede': '楓はこちらを一瞥し、何かを見抜いたように、それでもただ静かに笑った。「それでいい。この島じゃ、早々に全幅の信頼を置く人ほど、長くは生きられない。」',
  's.ch2.s2.rC.after': '笑って調子を合わせながら、胸の奥のどこかがそっと冷えていく。この島で生き延びる代償は、もう誰にも背中を預けきれなくなることなのかもしれない——いつか、自分自身さえ疑い始める日まで含めて。',
  's.ch2.s2.rB.after': '楓は長居せず、暗がりへ消える前にひと言だけ残した。「調べて。確かめ終わったら、診療所の裏口で待ってる——その時まだ、来る気があるなら。」その後ろ姿に責める色はなく、ただ、幾度も裏切られてなお待つことを選ぶ者の疲れだけがあった。',
  's.ch2.s3.1': '足取りを追い、診療所で流言の主を追い詰めた。よりによって、最も無害そうなあの転校生だった。',
  's.ch2.s3.2': '彼は笑って無線機を掲げた。「ただ生き延びたいだけさ……君たちも、そうだろう？」銃口は、もうあなたに向いていた。',
  's.ch2.s3.kaede': '楓があなたの半歩前に立ちはだかる。その声は刃のように冷たい。「偽の情報で死んだ人間は、あんたが『ただ生き延びたいだけ』だからって、戻ってはこない。無線機を置け——穏やかに言うのは、これが最後だ。」',
  's.ch2.s3.cA': '武器を下ろし、あいつに逃げ道をやる。',
  's.ch2.s3.cB': '退かない。ただ、無線を手放しさえすればいい。',
  's.ch2.s3.cC': 'こういう奴を残せば、次の被害者の伏線になる。',
  's.ch2.s3.rA': '君はゆっくりと武器を下げた。その一瞬、彼の目に迷いがよぎる——だが無線機が「ガッ」と鳴り、選ぶ余地はもう君の手にはなかった。',
  's.ch2.s3.rA.kaede': '楓が静かに言った。「あなたは私より優しい。どうかこの島が、その優しさをあなたの弱点に変えませんように。」',
  's.ch2.s3.rB': '君は退かなかった。けれど銃口は少しも上げない。「下ろせ。そうすれば、まだ歩いて帰れる。」——彼の指は、それでも引き金にかかっていく。',
  's.ch2.s3.rB.kaede': '楓は君の傍らに立ち、止めもせず、ただ低く付け足した。「機会はやった。この先は、あなたのせいじゃない。」',
  's.ch2.s3.rC': '君は最も冷たい判断を下した。言い終わる前に、体が先に動いていた。',
  's.ch2.s3.rC.kaede': '楓は止めなかった。ただ君を一瞥し、この瞬間を、彼女だけに見える名簿へそっと書き留めるように。',
  's.ch2.s4.1': '嘘が暴かれ、本物の殺し合いが続く。武器を握りしめ、この島の悪意に立ち向かう。',
  's.ch2.s4.sakura': '「『ただ生き延びたいだけ』——みんなそう言う。でも、その言葉を誰かを傷つける言い訳にはさせない。」',
  's.ch2.s4.end': '相手の無線機はまだ雑音を立てている。まるでこの島が今夜の名簿を数えているかのように。さくらがあなたの傍らに退き、もう何も言わない——残りの言葉は、これからの一歩一歩で答えるしかない。',

  // 第三章
  's.ch3.s1.scene': '観光協会ビルは島の東縁に建つ。掃き出し窓の外、港のクレーン灯が夜にまたたき、遠くの灯台の光が数秒おきに海面を薙ぐ。さらに内陸——学校の信号塔が、冷たい針のようにこの島の心臓へ突き刺さっている。',
  's.ch3.s1.kaede': '「ここよ。」楓は観光協会ビルのサーバ室でしゃがみ、指がキーボードを舞う。「運営の信号塔は学校にある。ここから逆に妨害できる。」',
  's.ch3.s1.kaede2': '彼女は振り向きもせず、低くつぶやいた。「戦うのは得意じゃない。でも、画面の向こうに隠れてる連中に、狙われる側の気分を味わわせるのは——得意なの。」',
  's.ch3.s1.1': '画面の進捗バーがゆっくり伸びる。彼女には時間が要る——そして時間は、この島で最も贅沢なものだ。',
  's.ch3.s1.voice': '【放送】生徒の皆さん、深夜のお知らせです。生存者数——十一名。昨夜より、七名減少。残された時間を、どうか大切に。',
  's.ch3.s1.mid': '一マスずつ伸びる進捗バーを見つめ、ふと滑稽で切なくなる——人を獣に変えるこの島で、彼らの希望は、まだ走り終えていない一行のコードにまで縮められている。それでもあなたは、その一行のために、すべての銃弾を引き受けようとしている。',
  's.ch3.s2.q': '遠くから足音と銃声が迫る。あなたは——',
  's.ch3.s2.cA': '入口を守り、楓のために食い止める',
  's.ch3.s2.cB': '機械が焼けるのを覚悟で、楓を急かす',
  's.ch3.s2.rA': '入口に壁のように立ちはだかる。「急いで、食い止める——たぶん。」',
  's.ch3.s2.rA.kaede': '楓は顔も上げず、指は操作盤の上を駆け続ける。それでも声が一瞬だけ和らいだ。「……無理はするな。おかしいと思ったら退け。あんたの命と引き換えの数秒なんて要らない。」少し間を置いて——「でも……ありがとう。この扉は、あんたに任せる。」',
  's.ch3.s2.rB': '「検証を飛ばして、直接流し込んで！」楓は歯を食いしばって従う。機械が耳障りな唸りを上げ、火花が散る。',
  's.ch3.s2.rB.after': '表示ランプが一気に赤く振り切れ、筐体は卵が焼けそうなほど熱い。「持ちこたえて……あと三十秒——」言い終える前に鈍い音、片側のパネルが暗転した。楓は歯を食いしばり予備系へ切り替える。「まだ動く。でも、チャンスはあと一回。無駄に焼かせないでよ。」',
  's.ch3.s2.cC': '陽動して、追っ手を別の場所へ誘い込む',
  's.ch3.s2.rC': '鋼管を掴み、廊下の反対側の鉄棚へ叩きつける。空のビルに轟音が炸裂した。足音は一斉に反響を追っていく——楓のために、数分をもぎ取った。',
  's.ch3.s2.rC.kaede': '「……あなた、私より頭の回転が速いね。」楓は思わず笑ったが、指先は止めない。「いい、あとは任せて——遠くへ行かないで。反響で誤魔化せるのは一瞬だから。」',
  's.ch3.s3.kaede': '「あと三分……いや、二分！」楓の額に汗がにじむ。',
  's.ch3.s3.bar': '進捗は、九十パーセントで止まった。',
  's.ch3.s3.sakura': '「楓、進捗バーじゃなくて私を見て。」さくらの声は静かで揺るがない。「あなたは信号を送ることだけ考えて。あとは私が引き受ける。一緒に入ったんだから、一緒に出るの。」',
  's.ch3.s3.kaede2': '「……うん。」楓は深く息を吸い、指先の震えが止まった。「ありがとう、さくら。あなたがいれば、本当にできる気がする。」',
  's.ch3.s3.beat': 'その一瞬、倉庫にはふたつの呼吸と、ゆっくり伸びていく一行の数字だけが残ったかのようだった。あなたはふいに、この瞬間を守りたくなる——この島で、まだ恐怖に食われずに残っている数少ないものを。',
  's.ch3.s3.1': 'その時、扉が蹴破られた。信号はまだ送れていない——だが敵は、もう来た。',
  's.ch3.s4.kaede': '「90％はゼロじゃない。あいつらを食い止めて——最後の二分を、私に預けて。」楓の指先は一瞬も止まらない。',
  's.ch3.s4.cA': '入口を死守する。一人も通さない。',
  's.ch3.s4.cB': '自分から出て、奴らを楓から引き離す。',
  's.ch3.s4.cC': '予備の武器をさくらに渡し、並んで防ぐ。',
  's.ch3.s4.rA': '君は唯一の入口に身を割り込ませ、廊下まるごとを一人ずつしか通れない狭き門に変えた。',
  's.ch3.s4.rA.kaede': '「いい位置。」楓は顔も上げずに言う。「来られるのは一度に一人——この二分、数字は私が守る。扉はあなたが守って。」',
  's.ch3.s4.rB': '君は彼らを待たず、踏み込んで飛び出し、戦いを倉庫から遠い側へと引き寄せた。',
  's.ch3.s4.rB.kaede': '「ちょっと——！」楓は息を呑み、すぐに君の狙いを悟って、奥歯を噛みしめ視線を画面へ戻した。「……生きて戻って。聞いてる？」',
  's.ch3.s4.rC': '君は予備の武器を振り向きざまにさくらへ放った。彼女はしっかり受け止め、君と背中合わせに立つ。',
  's.ch3.s4.rC.sakura': '「一緒に入ったんだから、一緒に防ぐ。」さくらは君と背を合わせる。「楓は数字を数えてればいい——この扉は、わたしたち二人でいい。」',
  's.ch3.s4.1': '計画の成否は、次の一戦にかかる。ひとつ深呼吸して、前に出た。',
  's.ch3.s4.end': '画面の進捗バーが一目盛りずつ上がっていく。まるで死とのレースのように。楓とその二分間を背中に庇う——この島が欲しがる答えは、拳で書いてやるつもりだ。',

  // 第四章
  's.ch4.s1.scene': '夜はさらに深まる。窪地から濃い霧が立ちのぼり、木の幹を、物音を呑み込み、自分の呼吸さえ場違いに響く。林の落ち葉を踏むたび、誰かの神経を踏みつけるようだ——本物の狩人は声を立てない。ただ、待つ。あなたはそれを理解しはじめる。',
  's.ch4.s1.voice': '【放送】禁止区域の拡大通知。北部の林縁がまもなく封鎖されます。霧中で行動する者はご注意を——視界は、けっして獲物の味方をしない。',
  's.ch4.s1.1': '雑木林の霧の中、ひとつの影が静かに立つ。まるで、ずっとあなたを待っていたかのように。凛だ。',
  's.ch4.s1.rin': '「楓の信号、あと一歩だったわね。惜しい——『あと一歩』は、遠いのよ。システムが落ちる前に、あなたたちを落とす。」',
  's.ch4.s1.mid': '銃口は揺るがない——憂さ晴らしではなく、代償を計算し尽くした決断を実行するかのように。ふと悟る。凛は狩りを愉しんでいるのではない。皆に代わって「手を下す」罪を、ひとりで先に背負っているだけだ。',
  's.ch4.s2.q': '彼女の指が引き金にかかる。あなたは——',
  's.ch4.s2.cA': '正面から迎え撃つ、生きるか死ぬか',
  's.ch4.s2.cB': '仲間に引き入れようと説得する',
  's.ch4.s2.cC': '霧に紛れて離脱する',
  's.ch4.s2.rA': '「来い。」武器を構える。退けない以上、進むしかない。',
  's.ch4.s2.rA.rin': '「いいだろう。」凛の唇の端がわずかに上がる——笑みではない、狩人が相手にする価値のある獲物を前にしたときの集中だ。「少なくとも跪いて死ぬつもりはないらしいな。その度胸は三手と持たない。だが、確かにあったと覚えておいてやる。」',
  's.ch4.s2.rA.after': 'あなたはその言葉の奥にあるものを聞き取った——侮っているのではない。彼女はとうに、何度も「相手の死に方」を予習してきたのだ。武器を握り直した瞬間、不思議と負けが怖くなくなった。黒沢凛に本気を出させられたなら、少なくとも自分はまだ、この島に数字へと挽き潰されてはいない。三手？なら、四手目まで数えさせてやる。',
  's.ch4.s2.rB': '「君は誰より分かってるはずだ、このゲームの馬鹿馬鹿しさを——なら、一緒にひっくり返さないか？」凛は半秒沈黙した。その半秒が、亀裂かもしれない。',
  's.ch4.s2.rB.rin': '「……一緒に？」彼女は視線を逸らしたが、銃口はわずかに下がった。「もし君を信じて、それでも失敗したら——私が迷ったせいで余計に死ぬ者は、誰が背負う？私は悪役でいい。もう誰かの命を賭けたくない。」',
  's.ch4.s2.rB.after': 'あなたはふいに、あの半秒の迷いの意味を悟る——凛はあなたを信じられないのではない。もう自分を信じるのが怖いのだ。すべての死を自分の借りとして背負ってきた彼女は、先に自分を怪物に変えた。そうすれば負けた日に、憎む相手はひとりで済むから。',
  's.ch4.s2.rC': '濃霧に身を翻し、林へ退く。彼女は追わない——狩人は、弾を無駄にしない。',
  's.ch4.s2.rC.rin': '霧の中、凛はあなたが消えた方へ、ほとんど自分にだけ聞かせるように呟いた。「逃げな。一晩でも長く生きろ。腹をくくったら、また私に借りを返しに来い。」',
  's.ch4.s2.rC.after': 'あの呟きを、あなたは確かに聞いていた。振り返らなかった——けれど胸に刻んだ。凛が逃がしたのは慈悲じゃない、賭けだ。彼女自身もまだ信じきれない答えを、あなたが持ち帰ることに賭けている。霧が背後で閉じ、あなたは足を速め、その重さごと夜へ連れていった。',
  's.ch4.s3.rin': '「勘違いしないで。助けたわけじゃない。最後の一発を誰に残すか、まだ決めてないだけ。」凛は影へ退いた——銃口は、ついぞ下ろさないまま。',
  's.ch4.s3.cA': '「一人で背負わなくていい」と彼女に叫ぶ。',
  's.ch4.s3.cB': '沈黙し、彼女が残した綻びを胸に刻む。',
  's.ch4.s3.cC': '武器を下ろさず、その迷いを警戒する。',
  's.ch4.s3.rA': '霧へ退いていく背中へ、君は一言叫んだ。声が出た途端、霧の中の足音が、半拍だけ止まった。',
  's.ch4.s3.rA.rin': '「……お節介。」凛の声が霧の奥から返ってくる。さっきより、ほんの少しだけ柔らかい。「でも——ありがとう。背中に撃たなかったこと。」',
  's.ch4.s3.rB': '君は声を出さず、彼女の言葉のあの綻びだけを、そっと胸の奥へしまった。いつか、また要るその日のために。',
  's.ch4.s3.rB.rin': '「黙る？それでいい。」霧の中の声は感情が読めない。「口を閉じられる奴のほうが、引き金を引ける奴より、たいてい長く生きる。」',
  's.ch4.s3.rC': '君は武器を下ろさず、霧の中のわずかな揺らぎも目で追った——彼女の迷いは本物だ。だがこの島は、迷う者に生き残る道を残しはしない。',
  's.ch4.s3.rC.rin': '「賢いね。」霧の奥から、ごく微かな息の音。称賛とも嘲りともつかない。「その警戒、私の前に来る前に使い切るなよ。」',
  's.ch4.s3.1': 'どんな選択をしようと、凛が最後の障害ではない。生き残りは、まだ続く。',
  's.ch4.s3.2': 'あなたは彼女の言葉の裂け目にようやく気づく——最も冷たい者さえ、引き金を引かずに済む理由を探しているのだと。',
  's.ch4.s3.end': '凛の姿が影に溶け、次の曲がり角はひとりで迎えることになる。遠くで銃声が絶え間なく交差する——この島は誰かが答えを出すのを待ってはくれない。次の殺し合いは、もうあなたを待っている。',

  // 第五章
  's.ch5.s1.scene': '夜明け前のもっとも深い闇の中、あなたたちは港の倉庫の隅で身を寄せ合う。潮が防波堤を打つ——一打ち、また一打ち。残りわずかな人数を数えるように。遠くの灯台は律儀に光を巡らせるが、その光は誰の目にも届かない。',
  's.ch5.s1.voice': '【放送】特別なお知らせ。生存者数が一桁に迫っています。主催よりご案内——生存者が残り三名となったとき、解除コードが各自の首輪へ送られます。優勝は目前。あなたが、隣にいる最後の数人を、自らの手で見送る気さえあれば。',
  's.ch5.s1.kaede': '「分かった。」楓の声が震える。「首輪の解除コードは『最後の三人』のとき、全員の首輪に送られる——優勝者への鍵よ。でも、誰かが囮になってくれれば……まるごと引き出せる。」',
  's.ch5.s1.1': '引き出すとは、誰かがわざと射程に踏み込み、信号の中継になること。成功すれば全員が助かり、失敗すればその者は即座に爆発する。',
  's.ch5.s1.mid': '一つの命で、皆の明日を買う——その計算はあまりに割が良く、吐き気がするほどだ。あなたはようやく首輪の本当の悪意を悟る。それは首を縛るだけでなく、「誰が死ぬべきか」を勘定する術を、皆に強いるのだ。',
  's.ch5.s1.hikari': '「じゃあ……時間は、わたしが数える。」ずっと黙っていたひかりがそっと手を挙げた。声は細いのに、揺るがない。「速く走れないし、戦えもしない。でも、誰かが秒を見ていて、誰かがあなたたちの帰る時刻を覚えていれば——あなたたちは、ただゼロになる数字じゃなくなる。それなら、わたしにもできる。」',
  's.ch5.s1.after': '戦うこともできないその手が、きちんと「計測開始」の仕草をするのを、あなたは見た。人を数字へと挽き潰してゆくこの島で、彼女はあえて「時間」そのものを守ろうとしている——帰ってくる誰もが、自分が誰だったかを忘れずにいられるように。ふと、この戦いは——本当に、戦う価値があるのかもしれない。',
  's.ch5.s2.q': '楓があなたを見る。今度ばかりは、誰も代わりに決められない。あなたは——',
  's.ch5.s2.cA': '自ら囮を買って出る',
  's.ch5.s2.cB': '犠牲のいらない方法を探す',
  's.ch5.s2.rA': '「俺が行く。」自分の声が聞こえた。さくらが止めようとするのを、そっと押しのける——一人でしか歩けない道がある。',
  's.ch5.s2.rA.sakura': '「絶対、生きて帰ってきて。」さくらは目を真っ赤にしながら、涙を無理やり押し戻した。「誰かが私の代わりに『犠牲』になるなんて許さない——あなたはただ先に行くだけ。あとから必ず追いつく。いい？」',
  's.ch5.s2.rA.after': '笑ってうなずき、「もし帰れなかったら」という言葉を呑み込む。中継点の座標が手のひらで熱を持つ。あなたはふいに、あのときの凛の気持ちが分かった——いちばん危険な場所を自分に残すのは、勇気じゃない。ただ、誰かが自分の代わりに死ぬのを、もう見ていられないだけだ。',
  's.ch5.s2.rB': '「きっと別の方法がある。」あきらめない。楓は苦笑した。',
  's.ch5.s2.rB.kaede': '「この島が、その時間をくれればいいけど。」',
  's.ch5.s2.rB.sakura': '「時間が足りないなら、自分たちでこじ開ける。」さくらは拳を握りしめた。声は大きくないのに、釘のように揺るがない。「誰も『代償』になんてさせない——今度こそ、『犠牲』なんて言葉、出させやしない。」',
  's.ch5.s2.rB.after': '誰も声を合わせはしなかったが、誰も目をそらさなかった。楓はうつむき、計画をもう一度数え直す——今度は、「間に合わない」の一語を、紙の上から消した。それは勝算ではない。ただ、時間に頭を垂れるのをやめると皆が決めただけだ。たとえ時間が、最初から味方ではなかったとしても。',
  's.ch5.s2.cC': '交代で分担し、誰も一人で死なせない',
  's.ch5.s2.rC': '「賭けるなら、みんなで賭ける。」あなたは言う。「中継は交代制。持たなくなったら替わる——『一人が死ぬ』を『全員で生き残る』に書き換えるんだ。」',
  's.ch5.s2.rC.kaede': '楓は一瞬呆け、すぐに力強く頷いた。瞳に光が戻る。「……そうだ。なんで気づかなかった。リスクを分ければ、計算が変わる。経路を引き直す——今度は、一人残らず数に入れて。」',
  's.ch5.s2.rC.after': '誰も英雄になる必要はない。誰も独りで死ぬことを許されない。その発想はあまりに単純で、単純すぎて、この島は君たちに思いつかせる気などなかった——島が欲しいのはたった一人の生存者。なのに君たちは、生きた人間をまるごと一群、突きつけてやる。',
  's.ch5.s3.1': '計画は最終段階へ。最初の陽光が水平線を裂くとき、この島のゲームも終局を迎える。',
  's.ch5.s3.kaede': '楓は最後のコードを書き込み、あなたの顔を見られずに目を逸らした。「中継の座標は……私が計算した。もし狂えば、私のせいだ。」ひとつ息を吸い、無理やり視線を上げる。「だから、絶対に帰ってきて——謝る機会と、礼を言う機会を、私にちょうだい。」',
  's.ch5.s3.hikari': '「時間を数えて、待ってるから。」ひかりの声は小さいのに、ひと言ひと言を静かに重ねる。「だから——絶対、帰ってきてね。」',
  's.ch5.s3.cA': '楓に言う——座標は信じてる。戻れなくても、君のせいじゃない。',
  's.ch5.s3.cB': 'ひかりに笑いかける——僕が戻るまで数えてて。一秒も欠かさずに。',
  's.ch5.s3.cC': '何も言わず、武器をもう一度点検する。',
  's.ch5.s3.rA': '君はまだ震えている楓の手を押さえ、一語一語をゆっくりと告げた。',
  's.ch5.s3.rA.kaede': '楓の目が一瞬で赤くなる。けれど意地で涙はこぼさない。「……それは戻ってから言って。『ごめん』も『ありがとう』も、あなたが帰ってきたその瞬間に、ぜんぶ取っておく。」',
  's.ch5.s3.rB': '君はひかりへ「頼む」と手で合図し、できるだけ軽い笑みを作った。',
  's.ch5.s3.rB.hikari': '「うん！」ひかりは力いっぱい頷き、ストップウォッチを胸に押し当てた。「すっごく大きな声で数えるね——どんなに遠くにいても、帰る拍子が聞こえるくらい。」',
  's.ch5.s3.rC': '君は多くを語らず、武器のひとつひとつを確かめ直した——弾倉、ストラップ、握りの感触。沈黙は時に、約束より本気に近い。',
  's.ch5.s3.rC.hikari': 'ひかりは君の背を見つめ、急かしもせず、計測の親指をそっとボタンに添えた。「……わかってる。言葉は、戻ってからでいい。」',
  's.ch5.s3.end': 'ひかりの言葉が、手のひらに握った温かな石のように残る。明けきらない空の光を最後に一度だけ見て、まだ消えぬ夜へと踏み出す——今度は、ただ生き延びるためじゃない。帰ってくるために。',

  // 終章
  's.ch6.s1.scene': '最初の灰白い光が水平線からにじみ出し、島全体が不自然な静けさに沈む——まるでこのゲームさえ、息を潜めているかのように。草の葉には夜露が結び、首の輪は相変わらず冷たく、昨夜が夢ではなかったと告げている。',
  's.ch6.s1.1': '島に残るのはわずか数人。銃声はまばらになり、かえって波の音が澄んで聞こえる。夜が、明ける。',
  's.ch6.s1.voice': '【放送】生徒の皆さん、最終通知です。生存者——三名。ここまで来たことを祝福します。『優勝者』まで、あと二つの名前を残すのみ。',
  's.ch6.s1.2': '灯台の下に立ち、無数の命と引き換えにした選択を手にする。最後の一歩は、あなたが決める。',
  's.ch6.s1.mid': '潮風の中、黎明にたどり着けなかった顔が次々と浮かぶ——刃から庇ってくれた者、最後まであなたの名を呼んでいた者。ふと悟る。この一歩は、ただ自分が生きるためではない。彼らが「生きていた」事実を、この島に易々と消させないためだ。',
  's.ch6.s1b.1': '心の中で、一人ずつ名前を呼んだ。名簿も番号もない——あなたが覚えている、笑い、泣いた級友たちだけ。',
  's.ch6.s1b.sakura': '「どの道を選んでも、」いつの間にかさくらが隣に立っていた。声は小さく、それでいて揺るがない。「最後まで一緒に行く。約束したでしょう——誰も、一人で背負わせたりしない。」',
  's.ch6.s1b.kaede': '「外せる仕掛けは、全部あんたに残しておいた。」いつの間にか楓もそこにいた。肩には、何度も改造したあの信号機。「あとは——あんたが結末を書く番だ。私たちは、それを見届ける役だよ。」',
  's.ch6.s1b.hikari': '「時間は……ずっと数えてるよ。」ひかりがそっと口を開いた。指先が手のひらを一つ、また一つと叩く。まるで誰かのために拍を刻むように。「あなたが帰ってくる時刻を、わたしは覚えてる。だから——必ず帰ってきて。わたしに、あなたを数えさせて。」',
  's.ch6.s1b.absent': '潮の匂いを乗せた風が吹き抜ける。ここまで共に来られなかった者もいる——その重さを口にする者はいないが、誰もが覚えている。',
  's.ch6.s1b.2': '灯台の光が海面を撫でる。まるでこの島の、最後のカウントダウンを数えるように。時が来た。',
  's.ch6.s2.q': '三つの道が目の前に開ける——どれも、何かと引き換えだ。ひとつ息を吸い、最後の選択をする——',
  's.ch6.s2.cA': '最後の生存者になる',
  's.ch6.s2.cB': '鍵を手に、島を脱出する',
  's.ch6.s2.cC': '卓を引っくり返し、最後まで抗う',
  's.ch6.e1.1': '最後まで生き延びた。ヘリの轟音が波をかき消すとき、名簿に残るのはあなただけ。',
  's.ch6.e1.2': '彼らはあなたに「優勝者」の称号を与える。だがあなたは知っている——生き残った者は、二度と安らかに眠れない。',
  's.ch6.e2.1': '解除コードが効き、首輪が次々と外れて落ちる。生きている者を連れ、港の船へ走る。',
  's.ch6.e2.2': 'エンジンがかかり、孤島は背後で黒い点になる。自由の味は、涙のように塩からい。',
  's.ch6.e3.1': '逃げも、独り生き残りもしなかった。楓が改造した信号を掲げ、監督教官の本部へ向ける。',
  's.ch6.e3.officer': '本部のスピーカーから、監督教官の声が初めて揺らいだ。「そのキーを押せば、何かが変わるとでも？このゲームは何十回も開催してきた。毎回、そう考える者がいた——」言葉は、あなたの信号にかき消された。',
  's.ch6.e3.2': '「このゲームは、もう終わりだ。」全画面が暗転するその瞬間、先に何があるかは分からない——だが少なくとも、彼らの書いた台本ではない。',
  's.ch6.e1.3': '「ごめん……そしてありがとう。生き延びる分まで、私に託してくれて。」誰もいない海へ、彼女は静かに呟いた。',
  's.ch6.e1.end': 'ヘリが上昇し、島は足元で色あせた傷跡のように縮んでいく。あなたはこのゲームに勝った——けれどこれから先、穏やかな夜のたびに、誰かが夢の中であなたの名を、そっと呼ぶだろう。',
  's.ch6.e2.3': '「私が組んだ信号は、誰かが明日を見られればよかっただけ。それが君たちなら——もう十分。」',
  's.ch6.e2.end': '甲板で歓声を上げる者はいなかった。生き残った者たちは船べりに身を寄せ、多くの名を呑み込んだ島が朝霧へと沈んでいくのを見つめていた。そこに永遠に留まった者がいることを、あなたは知っている——だからせめて、これからの明日を一日ずつ、その分まで生きていく。',
  's.ch6.e3.3': '「たとえこれが、もっと大きな檻だとしても。最初の扉は、この手でこじ開ける。」彼女は振り返らなかった。',
  's.ch6.e3.end': '本部の画面が一枚ずつ消え、カウントが尽き、放送が初めて静まり返った。ヘリもない、船もない、前にあるのは未知だけ——けれど今度は、次の頁をめくる手は、あなたたち自身のものだ。脚本は破かれた。物語は、生き延びた者の手で、ここから書き直される。',
  's.ch6.complete': '—— あなたの物語は、ここで一旦幕を下ろす。',
}

export default jaJP
